<template>
    <div id="asset_defect_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="AssetDefectHeader" v-if="$route.params.id > 0">Update Asset Defect</span>
                    <span class="page-title" id="AssetDefectHeader" v-else>Add Asset Defect</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackAssetDefectList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetDefectForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <input type="hidden" class="form-control" v-model="asset_defect_id" placeholder="" name="asset_defect_id">
                                    <div class="col form-group">
                                        <label class="control-label require" for="user_id">User:</label>    
                                        <v-select v-model="user_id" name="user_id" id="user_id"
                                            label="text" :filterable="false" :options="userArr"
                                            @search="onSearchUser"
                                            placeholder="Select User" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ user_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" id="vehicle_select" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchAsset"
                                            placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ asset_error_msg }}</div> 
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="report_time">Report Time:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="report_time" name="report_time" v-model="report_time" :config="optionsDate"></date-picker>
                                            <label for="report_time" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ report_time_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="odometer_reading">Reading:</label>
                                        <input type="text" class="form-control" v-model="odometer_reading" id="odometer_reading" placeholder="Enter Reading" name="odometer_reading">
                                        <div class="field-error">{{ odometer_reading_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="unit_id">Unit:</label>        
                                        <v-select v-model="unit_id" name="unit_id" placeholder="Select UOM"
                                            label="text"
                                            :options="vomArr">
                                        </v-select>
                                        <div class="field-error">{{ unit_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="source_id">Source:</label>        
                                        <v-select v-model="source_id" name="source_id" placeholder="Select Source"
                                            label="text"
                                            :options="sourcesArr">
                                        </v-select>
                                        <div class="field-error">{{ source_error_msg }}</div>
                                    </div>
                                </div>
                                <hr class="light-hr" v-if="defectitemsArr.length > 0"/>    
                                <template v-for="(defect, index) in defectitemsArr">
                                    <div class="form-row" v-bind:key="index">
                                        <div class="col-md-3 form-group">
                                            <label class="control-label require" for="defect.id">Defect:</label>
                                            <v-select class="defect-id" v-model="defect.defect_id" name="defect_id" placeholder="Select Defect"
                                                label="text"
                                                :options="standardDefectsArr">
                                            </v-select>
                                            <div class="field-error defect-id-error-msg">{{ defect.defect_error_msg }}</div>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label class="control-label require" for="defect_location">Location:</label>
                                            <v-select v-model="defect.defect_location" name="defect_location" placeholder="Select Location"
                                                label="text"
                                                :options="locationArr">
                                            </v-select>
                                            <div class="field-error section-value-error-msg">{{ defect.defect_location_error_msg }}</div>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label class="control-label require" for="defect_shop">Shop:</label>
                                            <v-select v-model="defect.defect_shop" name="defect_shop" placeholder="Select Shop"
                                                label="text"
                                                :options="shopArr">
                                            </v-select>
                                            <div class="field-error">{{ defect.defect_shop_error_msg }}</div>
                                        </div>
                                        <div class="col-md-2 form-group">
                                            <label class="control-label require" for="defect_status">Status:</label>
                                            <v-select v-model="defect.defect_status" name="defect_status" placeholder="Select Status"
                                                label="text"
                                                :options="statusArr">
                                            </v-select>
                                            
                                            <div class="field-error">{{ defect.defect_status_error_msg }}</div>
                                        </div>
                                        <div class="col-md-1 form-group text-right">
                                            <label class="control-label" style="display:block">&nbsp;&nbsp;</label>
                                            <template v-if="defectitemsArr.length != 1">
                                                <a href="" class="fp-remove" v-on:click.prevent="removeLine(index,defect.id)"></a>
                                                <br/>
                                            </template>
                                            <template>
                                                <a href="" class="fp-plus" v-if="index + 1 === defectitemsArr.length" v-on:click.prevent="addLine($event,index)"></a>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createAssetDefectBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateAssetDefect" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createAssetDefectBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateAssetDefect" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueAssetDefectBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateAssetDefect(flag='Save and Continue')" > 
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelAssetDefectBtn" class="btn btn-tertiary" v-on:click.prevent="BackAssetDefectList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

 



export default {
  name: "ContractCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Asset Defect | " +process.env.COPYRIGHT_NAME : "Create Asset Defect | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    userArr: [],
    user_id: null,
    user_error_msg: "",
    report_time: "",
    odometer_reading:"",
    odometer_reading_error_msg:"",
    unit_id: null,
    status:"",
    status_error_msg:"",
    source_id: null,
    sourcesArr: [],
    source_error_msg: "",
    statusArr: [],
    defect_id: null,
    defect_location: null,
    defect_shop: null,
    defect_status: null,
    defect_error_msg: "",
    defect_location_error_msg: "",
    defect_shop_error_msg: "",
    defect_status_error_msg: "",
    defectitemsArr: [],
    standardDefectsArr:[],
    shopArr: [],
    unit_error_msg: "",
    asset_defect_id: "",
    permissions: [],
    cantAccessPage: "",
    contract_id: "",
    code: "",
    contract_type_id: "",
    vehicle_id: null,
    vehicleArr: [],
    location_id: "",
    locationArr: [],
    vomArr: [],
    contractBillingMethodArr: [],
    cpiCodeArr: [],
    anniversaryPointArr: [],
    loading:false,
    editContract:false,
    contract_type_error_msg: "",
    code_error_msg: "",
    asset_error_msg: "",
    location_error_msg: "",
    report_time_error_msg: "",
    optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        toolbarPlacement:'bottom',
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
        },
        showClose: true,
    },
    cpi_code_error: "",
    blockRemoval: true
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_defect') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },

        vehicle_id: function(vehicle_id) {
            var self = this;
            if(self.vehicle_id == null){
                return;
            }
            if (self.vehicle_id.value != undefined) {
                self.defectItemData();
            }
            

        },
        defectitemsArr() {
            var self = this;
            self.blockRemoval = self.defectitemsArr.length <= 1
        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['location','vom','source','status','shop','standarddefects']);
        self.anniversaryPointArr = self.cpiAnniversaryPointArr;

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if(userObj != null){
            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
            if(dateTimeFormat != null){
                console.log(dateTimeFormat);
                //set date time format in optionsDate format of date picker
            }
        }

        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.contract_id = segments[3];
            self.loadAssetDefect();
        }
  },
  methods: {

    removeLine (lineId,id) {

        var self = this;
        if ( id == 0 ) {
            if (!self.blockRemoval) self.defectitemsArr.splice(lineId, 1)
        } else {
            if (confirm('Are you sure that you want to delete this Defect Item? ')) {
                $.ajax({
                    url: process.env.ROOT_API + "/assetdefect/remove-defect-item",
                    type: "POST",
                    data: {'id':id},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        if (data.status == "success" ) {
                            self.defectitemsArr.splice(lineId, 1);
                        }
                        
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'delete-asset-defect-item')
                    },
                });
            }
        }
        
    },

    addLine ($event, index) {

        var self = this;
        self.defectitemsArr[index].defect_location_error_msg = "";
        self.defectitemsArr[index].defect_error_msg = "";
        self.defectitemsArr[index].defect_shop_error_msg = "";
        self.defectitemsArr[index].defect_status_error_msg = "";
            
        if ( self.defectitemsArr[index].defect_location != null && self.defectitemsArr[index].defect_id != null && self.defectitemsArr[index].defect_shop != null && 
                self.defectitemsArr[index].defect_status != null) {

            self.defectitemsArr.push({
                id:0,
                defect_id: null,
                defect_location: null,
                defect_shop: null,
                defect_status: null,
                defect_error_msg: "",
                defect_location_error_msg: "",
                defect_shop_error_msg: "",
                defect_status_error_msg: "",
            })

        } else {

            if (self.defectitemsArr[index].defect_id == null || !self.defectitemsArr[index].defect_id.value) {
                self.defectitemsArr[index].defect_error_msg = "Defect Required.";
            }

            if (self.defectitemsArr[index].defect_location == null || self.defectitemsArr[index].defect_location == "" || self.defectitemsArr[index].defect_location == 0) {
                self.defectitemsArr[index].defect_location_error_msg = "Location Required.";
            }

            if (self.defectitemsArr[index].defect_shop == null || self.defectitemsArr[index].defect_shop == "") {
                self.defectitemsArr[index].defect_shop_error_msg = "Shop Required.";
            }

            if (self.defectitemsArr[index].defect_status == null || self.defectitemsArr[index].defect_status == "") {
                self.defectitemsArr[index].defect_status_error_msg = "Status Required.";
            }
        }
         
    },

    onSearchUser(search, loading) {
        var self = this;
        if (search.length > 0) {

            loading(true);
            self.searchField(loading, search, 'user', '');
        }
    },

    onSearchAsset(search, loading) {
        var self = this;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
    },

    defectItemData() {

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        $.ajax({
            url: process.env.ROOT_API + "/get-defect-item/search",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                asset_defect_item_id: segments[3],
            },
            success: function (data) {

                if (data.status == "success") {
                    self.defectitemsArr = [];
                    //self.defectitemsArr = data.content;
                    //set value for section selected if update page
                    for ( var i=0; i<data.content.length; i++ ) {
                        //initialize array
                        self.defectitemsArr.push({
                            id:null,
                            defect_id: null,
                            defect_location: null,
                            defect_shop: null,
                            defect_status: null,

                            defect_error_msg: "",
                            defect_location_error_msg: "",
                            defect_shop_error_msg: "",
                            defect_status_error_msg: "",
                        })
                        
                        self.defectitemsArr[i].id = (data.content[i].id != undefined && data.content[i].id != null)?data.content[i].id:0;
                        self.defectitemsArr[i].defect_id = (data.content[i].defect_id != undefined && data.content[i].defect_id != null)?{value: data.content[i].defect_id, text: self.titleCase(data.content[i].defect_name + " (" + data.content[i].defect_code +")")}:null;
                        self.defectitemsArr[i].defect_location = (data.content[i].defect_location != undefined && data.content[i].defect_location != null)?{value: data.content[i].defect_location, text: self.titleCase(data.content[i].defect_location_name + " (" + data.content[i].defect_location_code +")")}:null;
                        self.defectitemsArr[i].defect_shop = (data.content[i].defect_shop != undefined && data.content[i].defect_shop != null)?{value: data.content[i].defect_shop, text: self.titleCase(data.content[i].defect_shop_name + " (" + data.content[i].defect_shop_code +")")}:null;
                        self.defectitemsArr[i].defect_status = (data.content[i].defect_status != undefined && data.content[i].defect_status != null)?self.ucString(data.content[i].defect_status):null;
                    }
                    
                }
            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'get-asset-defect-item')
            }
        });
    },

    BackAssetDefectList() {
      var self = this;
      self.$router.push("/assetdefect/list");
    },

    CreateAssetDefect(flag) {
      var self = this;
      var error = false;

      self.user_error_msg = "";
      self.asset_error_msg = "";
      self.report_time_error_msg = "";
      self.odometer_reading_error_msg = "";
      self.source_error_msg = "";
      self.unit_error_msg = "";
      var defectArr = [];

      var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

      if (!self.odometer_reading || self.odometer_reading == null || self.odometer_reading == "") {
        self.odometer_reading_error_msg = "Odometer Reading Required.";
        error = true;
      } else {
          // PR - check reading is valid or not...
        if ( !String(self.odometer_reading).match(checkNumber) ) {
            self.odometer_reading_error_msg = "Odometer Reading is not valid.";
            error = true;
        }
      }

      if (self.user_id == null || !self.user_id.value) {
        self.user_error_msg = "User Required.";
        error = true;
      }

      if (!self.report_time || self.report_time == null || self.report_time == "") {
        self.report_time_error_msg = "Report Time Required.";
        error = true;
      }

      if (self.unit_id == null || !self.unit_id.value) {
        self.unit_error_msg = "UOM Required.";
        error = true;
      }
        
      if (self.source_id == null || !self.source_id.value) {
        self.source_error_msg = "Source Required.";
        error = true;
      }

      if (self.vehicle_id == null || !self.vehicle_id.value) {
        self.asset_error_msg = "Asset Required.";
        error = true;
      }

      for (var i=0; i<self.defectitemsArr.length; i++) {

            self.defectitemsArr[i].defect_error_msg = "";
            self.defectitemsArr[i].defect_location_error_msg = "";
            self.defectitemsArr[i].defect_shop_error_msg = "";
            self.defectitemsArr[i].defect_status_error_msg = "";
            
            if ( self.defectitemsArr[i].defect_id != undefined && defectArr.includes(self.defectitemsArr[i].defect_id.value)) {
                self.defectitemsArr[i].defect_error_msg = "This Section Rate has been already added.";
                error = true;
            }
            
            
            if ( self.defectitemsArr[i].defect_id == null || !self.defectitemsArr[i].defect_id.value ) {

                self.defectitemsArr[i].defect_error_msg = "Defect Required.";
                error = true;
            } else {
                defectArr.push(self.defectitemsArr[i].defect_id.value);
            }

            if (self.defectitemsArr[i].defect_location == null || self.defectitemsArr[i].defect_location.value == 0) {
                
                self.defectitemsArr[i].defect_location_error_msg = "Location Required.";
                error = true;
            }

            if (self.defectitemsArr[i].defect_shop == null || self.defectitemsArr[i].defect_shop.value == 0) {
                
                self.defectitemsArr[i].defect_shop_error_msg = "Shop Required.";
                error = true;
            }

            if ( self.defectitemsArr[i].defect_status == null || self.defectitemsArr[i].defect_status == "") {
                
                self.defectitemsArr[i].defect_status_error_msg = "Status Required.";
                error = true;
            }
            
        }
      
      if (!error) {

            var defectStatusIdArr = [];
            var defectShopIdArr = [];
            var defectIdArr = [];
            var defectLocationIdArr = [];
            var limitArr = [];
            var assDefectItemIdArr = [];

            for (var i = 0; i<self.defectitemsArr.length;i++) {

                assDefectItemIdArr.push(self.defectitemsArr[i].id);
                defectStatusIdArr.push(self.defectitemsArr[i].defect_status);
                defectShopIdArr.push(self.defectitemsArr[i].defect_shop.value);
                defectIdArr.push(self.defectitemsArr[i].defect_id.value);
                defectLocationIdArr.push(self.defectitemsArr[i].defect_location.value);
                // limitArr.push(self.defectitemsArr[i].limit_percent);
            }

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateAssetDefectBtn").val("Updating ...");
                $("#CreateAssetDefectBtn").prop("disabled", true);
                $("#cancelAssetDefectBtn").prop("disabled",true);

            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueAssetDefectBtn").val("Saving ...");
                    $("#CreateAssetDefectBtn").prop("disabled", true);
                    $("#createAndContinueAssetDefectBtn").prop("disabled", true);
                    $("#cancelAssetDefectBtn").prop("disabled",true);

                }else{

                    $("#CreateAssetDefectBtn").val("Saving ...");
                    $("#CreateAssetDefectBtn").prop("disabled", true);
                    $("#createAndContinueAssetDefectBtn").prop("disabled", true);
                    $("#cancelAssetDefectBtn").prop("disabled",true);
                }

            }

            var fields = $("#AssetDefectForm").serializeArray();
            fields.push({name: "user_id", value: self.user_id.value});
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            fields.push({name: "source_id", value: self.source_id.value});
            fields.push({name: "unit_id", value: self.unit_id.value});
            fields.push({name: "defect_status", value: defectStatusIdArr});
            fields.push({name: "defect_shop_id", value: defectShopIdArr});
            fields.push({name: "defect_id", value: defectIdArr});
            fields.push({name: "defect_location_id", value: defectLocationIdArr});
            fields.push({name: "asset_defect_item_id", value: assDefectItemIdArr});
            fields.push({name: "id", value: segments[3]});
            console.log(fields);//return;
            $.ajax({
                url: process.env.ROOT_API + "/assetdefect/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetDefectBtn").val("Update");
                        $("#CreateAssetDefectBtn").prop("disabled", false);
                        $("#cancelAssetDefectBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueAssetDefectBtn").val("Save and Continue");
                            $("#CreateAssetDefectBtn").prop("disabled", false);
                            $("#createAndContinueAssetDefectBtn").prop("disabled", false);
                            $("#cancelAssetDefectBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetDefectBtn").val("Save");
                            $("#CreateAssetDefectBtn").prop("disabled", false);
                            $("#createAndContinueAssetDefectBtn").prop("disabled", false);
                            $("#cancelAssetDefectBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#AssetDefectForm").trigger("reset");
                            self.odometer_reading ="";
                            self.user_id = null;
                            self.vehicle_id = null;
                            self.unit_id = null;
                            self.source_id = null;
                            self.report_time = "";
                            // self.section_rates = "";
                            self.defectitemsArr = [];      //empty array for section rates
                    
                        }else{
                            self.$router.push("/assetdefect/list");
                        }
                        $(".alert-contract").empty();
                        $(".alert-contract").removeClass("show");
                        $(".alert-contract").addClass("hide");

                    } else {
                        if (data.content.length > 0) {
                            var err = "<ul>";
                            $(".alert-contract").empty();

                            for (var i = 0; i < data.content.length; i++) {
                                err += "<li>" + data.content[i] + "</li>";
                            }
                            err += "</ul>";
                            $(".alert-contract").append(err);
                            $(".alert-contract").addClass("show");
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            // setTimeout(function () {
                                // $(".alert-warning").removeClass("show");
                                // $(".alert-warning").addClass("hide");
                            // }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetDefectBtn").val("Update");
                        $("#CreateAssetDefectBtn").prop("disabled", false);
                        $("#cancelAssetDefectBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#AssetDefectForm").trigger("reset");
                            

                            $("#createAndContinueAssetDefectBtn").val("Save and Continue");
                            $("#CreateAssetDefectBtn").prop("disabled", false);
                            $("#createAndContinueAssetDefectBtn").prop("disabled", false);
                            $("#cancelAssetDefectBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetDefectBtn").val("Save");
                            $("#CreateAssetDefectBtn").prop("disabled", false);
                            $("#createAndContinueAssetDefectBtn").prop("disabled", false);
                            $("#cancelAssetDefectBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'create-asset-defect')
                }
            });
      }else{
            self.errorValidationFocus();
      }
    },

    loadAssetDefect() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetdefect/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    $("#vehicle_select").addClass("js-example-disabled");
                    self.report_time = data.content.report_time;
                    self.odometer_reading = data.content.odometer_reading;
                    self.asset_defect_id = data.content.asset_defect_id;
                    // self.vehicle_id = {value: data.content.vehicle_id, text: self.titleCase(data.content.vehicleName + " (" + data.content.vehicleUnitNo +")" + " (" + data.content.vtCode +")")};
                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.vehicleUnitNo);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vehicleName != null){
                            vehicleData += " | " + self.titleCase(data.content.vehicleName);
                        }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                    }else{
                        self.vehicle_id = null;
                    }
                    self.user_id = {value: data.content.user_id, text: self.titleCase(data.content.userName)};
                    self.source_id = {value: data.content.source_id, text: self.titleCase(data.content.sourceName + " (" + data.content.sourceCode +")")};
                    self.unit_id = {value: data.content.unit_id, text: self.titleCase(data.content.unitName + " (" + data.content.unitSymbol +")")};
                    self.defectItemData();

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-asset-defect')
            }
        });
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
  }
};
</script>
<style scoped>
/* disable v-select of Asset on Edit*/
.js-example-disabled {
    pointer-events:none;
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
}
</style>


// WEBPACK FOOTER //
// src/components/AssetDefectCreate.vue